import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import useChapterActionIdMatch from "../../../hooks/useChapterActionIdMatch";

import ToolBlock from "../../../components/AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";
import SearchBlockRHF from "../../../components/GeneralComponents/searchBlockRHF/SearchBlockRHF";
import ModalWindowWithInputs from "../../../components/GeneralComponents/modalWindowWithInputs/modalWindowWithInputs";
import ResultModalWindow from "../../../components/AdministrativeProcedures/commonComponents/ResultModalWindow/ResultModalWindow";
import TableComponent from "../../../components/GeneralComponents/SearchTable/tableComponent";

import {
  clearAccidentData,
  getAccidentInfoById,
  terminationCase,
} from "../../../redux/TransportAccidentsReportReducer/actionsTransportAccidentsReport";
import { getDataTransportAccidentBySearchParams } from "../../../redux/actions";

import { SET_ERROR_TERMINATION_CASE } from "../../../redux/types";

import {
  options,
  setOptionsSections,
} from "../../../components/GeneralComponents/searchBlockRHF/optionsSearchBlockRHF";
import { accidentModalInputs } from "./transportAccidentsReportOptions";
import { TRANSPORT_ACCIDENT_COLUMNS } from "../../../components/GeneralComponents/SearchTable/TablesColumns";

import styles from "./TransportAccidentsReport.module.css";

export default function TransportAccidentsReport() {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    clearErrors,
  } = useForm({
    mode: "onChange",
  });

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [selectedPage, setSelectedPage] = useState(0);
  const [show, setShow] = useState(false);
  const [showResultModal, setShowResultModal] = useState(false);
  const [textForResultModal, setTextForResultModal] = useState("");
  const [showModalWindowWithInputs, setShowModalWindowWithInputs] = useState(false);
  const [searchParams, setSearchParams] = useState({
    section: 0,
    ownerSurname: "",
    ownerName: "",
    ownerMidname: "",
    boatRegNum: "",
    incidentType: 0,
    date1: "",
    date2: "",
    driverDrunk: 0,
    incidentPlace: "",
    incidentStatus: 4,
  });

  const saveStatusTerminationAccidents = useSelector((state) => {
    const { TransportAccidentsReportReducer } = state;
    return TransportAccidentsReportReducer.saveErrorTerminationCase;
  });
  const sortedMenuNames = useSelector((state) => {
    const { roleControllerReducer } = state;
    return roleControllerReducer.sortedMenuNames;
  });
  const addAccess = useChapterActionIdMatch(
    sortedMenuNames?.BOAT_INCIDENTS?.addATransportEmergency?.chapterActionId,
  );
  const viewAccess = useChapterActionIdMatch(
    sortedMenuNames?.BOAT_INCIDENTS?.viewTransportEmergency?.chapterActionId,
  );
  const editAccess = useChapterActionIdMatch(
    sortedMenuNames?.BOAT_INCIDENTS?.editTransportEmergency?.chapterActionId,
  );

  const dataFromStateTransportAccidents = useSelector((state) => {
    const { TransportAccidentsReportReducer } = state;
    return TransportAccidentsReportReducer.data;
  });
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });
  const accidentData = useSelector((state) => {
    const { TransportAccidentsReportReducer } = state;
    return TransportAccidentsReportReducer.newAccidentData;
  });

  const dispatch = useDispatch();

  const handleModalWindow = (data) => {
    if (data && selectedRowData) {
      dispatch(terminationCase(selectedRowData.id, data));
    }
  };
  const handleClear = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    setSearchParams(
      structuredClone({
        section: 0,
        ownerSurname: "",
        ownerName: "",
        ownerMidname: "",
        boatRegNum: "",
        incidentType: 0,
        date1: "",
        date2: "",
        driverDrunk: 0,
        incidentPlace: "",
        incidentStatus: 4,
      }),
    );
    dispatch(
      getDataTransportAccidentBySearchParams(
        {
          section: 0,
          ownerSurname: "",
          ownerName: "",
          ownerMidname: "",
          boatRegNum: "",
          incidentType: 0,
          date1: "",
          date2: "",
          driverDrunk: 0,
          incidentPlace: "",
          incidentStatus: 4,
        },
        0,
      ),
    );
  };

  const handleChange = (e) => {
    if (e.target) {
      setSearchParams({
        ...searchParams,
        [e.target.dataset.id]: e.target.value,
      });
    } else {
      setSearchParams({ ...searchParams, [e.key]: e.value });
    }
  };

  const handleRowSelect = (rowData) => {
    dispatch(clearAccidentData());
    dispatch(getAccidentInfoById(rowData.id));
    setSelectedRowData(rowData);
  };

  const fetchPageData = (pageIndex) => {
    setSelectedPage(pageIndex);
  };

  const handleSearch = () => {
    setSelectedPage(0);
    setSelectedRowData(null);
    dispatch(getDataTransportAccidentBySearchParams(searchParams, 0));
  };

  useMemo(() => {
    setSelectedRowData(null);
    dispatch(getDataTransportAccidentBySearchParams(searchParams, selectedPage));
  }, [selectedPage]);

  useEffect(() => {
    if (saveStatusTerminationAccidents === "reject") {
      setTextForResultModal("Ошибка при прекращении дела!");
      setShowResultModal(true);
    }
    if (saveStatusTerminationAccidents === "success") {
      setTextForResultModal("Дело прекращено!");
      setShowResultModal(true);
    }
  }, [saveStatusTerminationAccidents]);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(dictionaryReducer.gimsSections, options.inputsTransportAccidentsReport.key);
    }
  }, [dictionaryReducer]);

  useEffect(() => {
    if (dictionaryReducer.gimsSections.length > 0) {
      setOptionsSections(dictionaryReducer.gimsSections, options.inputsTransportAccidentsReport.key);
    }
  }, []);
  useEffect(() => {
    fetchPageData(0);
  }, []);

  return (
    <div className={styles["content-container"]}>
      <SearchBlockRHF
        options={options.inputsTransportAccidentsReport}
        handleChange={handleChange}
        handleSearch={handleSearch}
        handleClear={handleClear}
        searchParams={searchParams}
        externalStyles={styles}
      />
      <ToolBlock
        id={selectedRowData?.id}
        appStatusId={selectedRowData?.incidentStatus}
        show={show}
        setShow={setShow}
        editAccess={editAccess}
        addAccess={addAccess}
        viewAccess={viewAccess}
        externalButtonSettings={{
          btnText: "Прекратить",
          access: true,
          disabled: selectedRowData?.incidentStatus !== "Сформировано",
          handler: () => setShowModalWindowWithInputs(true),
        }}
      />
      <TableComponent
        fetchData={fetchPageData}
        onRowSelect={handleRowSelect}
        columns={TRANSPORT_ACCIDENT_COLUMNS}
        data={dataFromStateTransportAccidents.content || []}
        totalPages={dataFromStateTransportAccidents.totalPages || 0}
        totalElements={dataFromStateTransportAccidents.totalElements || 0}
        selectedPage={selectedPage}
      />
      <ModalWindowWithInputs
        showModal={showModalWindowWithInputs}
        setShowModal={setShowModalWindowWithInputs}
        textButton={"Сохранить"}
        externalStyles={styles}
        inputsOptions={accidentModalInputs}
        mode={"add"}
        handle={handleModalWindow}
        handleSubmit={handleSubmit}
        register={register}
        control={control}
        setValue={setValue}
        errors={errors}
        clearErrors={clearErrors}
        data={accidentData}
      />

      {showResultModal && (
        <ResultModalWindow
          show={showResultModal}
          setShow={setShowResultModal}
          headerTextExternal={textForResultModal}
          result={saveStatusTerminationAccidents}
          handleCloseApp={() => {
            if (saveStatusTerminationAccidents !== "reject") {
              dispatch(getDataTransportAccidentBySearchParams(searchParams, 0));
              setSelectedRowData(null);
              setShowModalWindowWithInputs(false);
              setShowResultModal(false);
              dispatch(clearAccidentData());
              dispatch({
                type: SET_ERROR_TERMINATION_CASE,
                data: "",
              });
            } else {
              setShowResultModal(false);
              dispatch({
                type: SET_ERROR_TERMINATION_CASE,
                data: "",
              });
            }
          }}
        />
      )}
    </div>
  );
}
